export class UnwindStageImpl {
    constructor(arrayFieldName) {
        this.arrayFieldName = arrayFieldName;
    }
    toProto() {
        return { unwindArray: { arrayFieldName: this.arrayFieldName } };
    }
}
//# sourceMappingURL=UnwindStage.js.map